<template>
  <div
    v-if="matchInfo.homeTeam"
    class="m-live-summary"
    :class="{
      tennis: matchInfo.sportId === 'sr:sport:5',
      'm-live-summary-special': isSpecial
    }"
  >
    <div class="m-meta">
      <LeagueInfo
        :category="matchInfo.category"
        :category-icon="matchInfo.categoryIcon"
        :tournament="matchInfo.tournament"
        :tournament-id="matchInfo.tournamentId"
        :sport-name="matchInfo.sport"
      />
      <!-- match label -->
      <IconMatchLabels
        v-if="isSpecial"
        class="tw-h-[12px] tw-ml-[5px]"
        :options="{
          configKey: 'commonLabeUrl',
          displayIn: '4',
          sportId: matchInfo.sportId,
          tournamentId: matchInfo.tournamentId,
          eventStatus: matchInfo.status
        }"
      />
    </div>

    <div :class="['teams-info', { 'teams-info-special': isSpecial }]">
      <div
        v-if="!isSpecial"
        class="m-meta"
      >
        <span
          v-if="matchTime"
          class="m-time"
        >{{ matchTime }}</span>
        <span
          v-if="formattedStoppageTime"
          class="m-stoppage-time"
        >
          {{ formattedStoppageTime }}
        </span>
        <span
          v-if="matchStage"
          class="m-status"
        >{{ matchStage }}</span>

        <!-- match label -->
        <IconMatchLabels
          class="tw-h-[12px] tw-ml-[5px]"
          :options="{
            configKey: 'commonLabeUrl',
            displayIn: '4',
            sportId: matchInfo.sportId,
            tournamentId: matchInfo.tournamentId,
            eventStatus: matchInfo.status
          }"
        />
      </div>
      <div class="m-teams">
        <div class="m-teams-data">
          <div class="m-teams--info">
            <div
              v-if="isSpecial"
              class="m-meta"
            >
              <span
                v-if="matchTime"
                class="m-time"
              >{{ matchTime }}</span>
              <span
                v-if="formattedStoppageTime"
                class="m-stoppage-time"
              >
                {{ formattedStoppageTime }}
              </span>
              <span
                v-if="matchStage"
                class="m-status"
              >{{ matchStage }}</span>
            </div>
            <div class="m-team-name m-home-team">
              <img
                v-if="isServerVisible"
                class="m-server-icon"
                :class="{'active': isHomeServer}"
                :src="serverIcon"
              >
              <span>{{ matchInfo.homeTeam }}</span>
            </div>
            <div class="m-team-name m-away-team">
              <img
                v-if="isServerVisible"
                class="m-server-icon"
                :class="{'active': isAwayServer}"
                :src="serverIcon"
              >
              <span>{{ matchInfo.awayTeam }}</span>
            </div>
          </div>
        </div>

        <div class="m-teams-scores">
          <template v-if="isSpecial">
            <div class="data-info">
              <EventData
                v-if="matchInfo.soccerCornerScore"
                :number-data="matchInfo.soccerCornerScore"
                :active="isActive"
              >
                <img
                  class="title"
                  src="../images/corner.png"
                  @click="showDesc(0)"
                >
              </EventData>
              <EventData
                v-if="matchInfo.soccerBookingsScore"
                :number-data="matchInfo.soccerBookingsScore"
                :active="isActive"
              >
                <img
                  class="title"
                  src="../images/card.png"
                  @click="showDesc(1)"
                >
              </EventData>
            </div>
            <div
              v-if="matchInfo.allScores"
              :class="['score-data', { 'score-data-special': matchInfo.sportId === 'sr:sport:1' }]"
            >
              <EventData
                v-for="(score, index) in matchInfo.allScores"
                :key="index"
                :title="score[0]"
                :number-data="score[1]"
                :active="score[0] === matchStage"
              />
            </div>
          </template>
          <template v-else>
            <!-- live 比赛显示比分 -->
            <MatchScores
              class="m-teams--score"
              :score-of-whole-match="matchInfo.scoreOfWholeMatch"
              :score-of-section="matchInfo.scoreOfSection"
              :score-in-current-section="matchInfo.scoreInCurrentSection"
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, getCurrentInstance, ref } from '@vue/composition-api'
import useMatchInfo from '@ms/components/match/useMatchInfo.js'
import useMatchTime from '@ms/components/match/composables/useMatchTime.js'
// import useMatch from '@ms/components/match/useMatch.js'
import { getMatchStatusDescription } from '@ms/components/match/status.js'
import modalHelper from '@ms/utils/scroll-fixed'
import MatchScores from '@ms/components/match/MatchScores.vue'
import IconMatchLabels from '@ms/components/IconMatchLabels.vue'
import LeagueInfo from '../../components/LeagueInfo'
import EventData from './EventData.vue'
import { useSportServer } from 'composables/useSportServer'

export default {
  name: 'LiveSummary',
  components: {
    MatchScores,
    IconMatchLabels,
    LeagueInfo,
    EventData
  },
  setup() {
    const { proxy: vm } = getCurrentInstance()
    const { matchInfo, sportId, server } = useMatchInfo()
    const { showTime: matchTime, formattedStoppageTime } = useMatchTime(matchInfo, { sportId })

    // const {
    //   matchStage
    // } = useMatch({ event: matchInfo })

    // 当前比赛阶段
    const matchStage = computed(() => {
      const { sportId, statusDescription } = matchInfo.value
      return getMatchStatusDescription({ sportId, statusDescription })
    })

    const isSpecial = computed(() => {
      const { sportId } = matchInfo.value
      return sportId === 'sr:sport:1' || sportId === 'sr:sport:2'
    })

    const isActive = computed(() => {
      const { allScores } = matchInfo.value
      const len = allScores?.length
      if (len) {
        const score = allScores[len - 1]
        return score[0].toLowerCase() === 'ht' || score[0].toLowerCase() === 'ft'
      }
      return false
    })

    const showDesc = (type) => {
      let title = ''
      let message = ''
      const time = '<em style="color: #43bc9c;">Full Time</em>'

      if (!type) {
        title = 'Corners'
        message = `
        <p style="margin-bottom: 16px; color: #333px; line-height: 18px; font-size: 14px;">This statistics show the total corner number of each team. <i style="color: #43bc9c;">*</i>${time}</p>
        <p style="color: #999px; line-height: 18px; font-size: 14px; font-style: italic;">* ${time} includes the first half, the second half, and all injury and stoppage time, does not include overtime and penalty time.</p>
        `
      } else {
        title = 'Bookings'
        message = `
        <p style="margin-bottom: 16px; color: #333px; line-height: 18px; font-size: 14px;">This statistics show the total bookings of each team. Yellow card = 1 booking; Red card = 2 bookings. <i style="color: #43bc9c;">*</i>${time}</p>
        <p style="margin-bottom: 10px; color: #999px; line-height: 18px; font-size: 14px; font-style: italic;">* ${time} includes the first half, the second half, and all injury and stoppage time, does not include overtime and penalty time.</p>
        <p style="margin-bottom: 10px; color: #999px; line-height: 18px; font-size: 14px; font-style: italic;">* Cards shown after the match are not considered.</p>
        <p style="color: #999px; line-height: 18px; font-size: 14px; font-style: italic;">* Cards for non-players (already substitutes players, managers, players on bench) are not considered.</p>
        `
      }

      vm.$dialog({
        title,
        message,
        classNames: ['m-detail-hearder-dialog'],
        closeOnClickModal: true,
        dangerouslyUseHTMLString: true
      })
        .then(() => {
          modalHelper.beforeClose()
        })
        .catch(() => {
          modalHelper.beforeClose()
        })
      modalHelper.afterOpen()
    }

    const { serverIcon, isServerVisible, isHomeServer, isAwayServer } = useSportServer({
      sportId,
      server,
      isLive: ref(true)
    })

    return {
      matchTime,
      formattedStoppageTime,
      matchInfo,
      matchStage,
      isSpecial,
      isActive,
      showDesc,
      serverIcon,
      isServerVisible,
      isHomeServer,
      isAwayServer
    }
  }
}
</script>

<style lang="scss" scoped>
[data-mode="light"] .m-live-summary {
  background: #f8f8f8;
  color: #999;

  .m-meta {
    background: linear-gradient(180deg,#fff 0%,#f7f7f7 100%);
  }

  .meta-league-info {
    color: #666;

    a { color: #000; }
  }

  .teams-info {
    background: #fff;

    .m-teams::before,.m-teams::after { background: #f8f8f8; }

    .m-team-name {
      background: #f8f8f8;
      color: #000;

      .m-server-icon {
        filter: grayscale(1);
      }
    }

    .m-meta { background: #fff; }

    .m-time { color: #ff7d1e; }

    .m-stoppage-time { color: #666; }

    .m-status { color: #ff7d1e; }

    ::v-deep .m-score-wrap {
      color: #000;

      &.whole-score {
        color: #FF7D1E;
      }

      .m-score {
        background:#fff;
        box-shadow:0 0 1px rgba(0, 0, 0, 18%);
      }
    }

    ::v-deep .live-event-data {
      .home,.away {
        color: #000;
      }

      &:last-child {
        .title {
          color: #000;
        }
      }
    }

    ::v-deep .score-data .live-event-data:last-child {
      .home, .away {
        background:#fff;
        box-shadow: 0 0 1px rgba(0, 0, 0, 18%);
        color: #ff7d1e;
      }
    }
  }
}
</style>

<style lang="less">
@import url("~wap/common/style/variable.less");
@import url("~wap/common/style/mixin.less");

.m-live-summary {
  background: #000;
  color: #999;
  font-size: 10px;
  line-height: 14px;

  .m-meta {
    padding: 0 16px;
    font-size: 12px;

    & > span,
    i {
      vertical-align: top;
    }

    .m-time {
      display: inline-block;
      width: 35px;
      color: @primary;
    }

    .m-stoppage-time {
      margin-left: 4px;
    }

    .m-status {
      margin-left: 4px;
      color: @primary;
    }

    .meta-league-info {
      & > span {
        .ellipsis();
      }
    }
  }

  .teams-info {
    padding: 6px 16px;
    background: #161616;

    .m-meta {
      padding: 0;
    }
  }

  .m-teams-data {
    display: flex;
    flex: 1;
  }

  .m-teams {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
    margin-top: 10/@rem;

    .m-teams--info {
      width: 88%;
      flex: 1;

      .m-team-name {
        display: flex;
        height: 28px;
        box-sizing: border-box;
        align-items: center;
        padding: 0 10px;
        border-radius: 14px;
        margin-bottom: 4px;
        background: #000;
        color: #fff;
        font-family: Roboto;
        font-size: 12px;
        line-height: 28px;

        & > span {
          .ellipsis();
        }
        

        .m-server-icon {
          width: 8px;
          height: 8px;
          margin-right: 6px;
          filter: brightness(0.4) grayscale(1);

          &.active {
            filter: brightness(1) grayscale(0);
          }
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    &--score {
      .m-score-wrap {
        margin-left: 4px;
        color: #fff;

        .m-score {
          width: 36px;
          height: 28px;
          border-radius: 14px;
          margin-bottom: 4px;
          background: #323232;
          font-size: 14px;
          line-height: 28px;
          text-align: center;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }

  &.tennis {
    .m-teams {
      .m-teams--info {
        width: (218/330) * 100%;
      }
    }
  }

  &-special {
    position: sticky;
    z-index: 1000;
    top: 4px;

    .m-meta {
      display: flex;
      align-items: center;
      margin-bottom: 0;
    }

    .teams-info {
      padding: 22px 16px 6px;

      .m-meta {
        padding: 0;
      }

      .m-teams-data {
        position: relative;
        z-index: 1;
        display: flex;
        width: 0;
        flex: 1;
      }
    }

    .m-teams {
      position: relative;
      z-index: 1;
      margin-top: 6px;

      &::before,
      &::after {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 28px;
        border-radius: 14px;
        background: #000;
        content: "";
      }

      &::after {
        top: unset;
        bottom: 0;
      }

      .m-teams--info {
        position: relative;
        z-index: 1;
        width: unset;
        max-width: 100%;
        box-sizing: border-box;
        flex: unset;
        margin-top: -28px;
        .ellipsis();

        .m-meta {
          padding: 6px 0;
          .ellipsis();

          .m-status {
            .ellipsis();
          }
        }

        .m-team-name {
          height: 28px;
          box-sizing: border-box;
          padding: 0 0 0 12px;
          background: unset;
          line-height: 28px;
          .ellipsis();
        }
      }

      .m-score {
        position: relative;
        z-index: 1;
        width: 36px !important;
        height: 28px !important;
        border-radius: 14px !important;
        line-height: 28px !important;
      }
    }

    .m-teams-scores {
      display: flex;

      .data-info {
        top: 0;
        right: 0;
        display: flex;
      }

      .score-data {
        display: flex;
        justify-content: right;

        &.score-data-special {
          min-width: 154px;
        }

        .live-event-data:last-child {
          margin-left: 13px;

          .title,
          .home,
          .away {
            width: 36px;
            color: #ffcb2c;
          }

          .home,
          .away {
            border-radius: 14px;
            background: #2c2c2c;
            font-size: 14px;
            font-weight: 500;
          }
        }
      }
    }
  }
}

.m-detail-hearder-dialog {
  .dialog--header {
    padding-top: 30px;
  }

  .dialog--body {
    padding: 0 20px 20px;
  }

  .dialog--footer {
    display: none;
  }
}
</style>
